import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=60cda22a&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=60cda22a&prod&scoped=true&lang=css"
import style1 from "./Rooms.vue?vue&type=style&index=1&id=60cda22a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cda22a",
  null
  
)

export default component.exports